import _ from 'lodash';

const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

const VIEWS = 1;
const MINS = 2;
const LIKES = 3;
const COMMENTS = 4;
const SHARES = 6;
const ISO = 0;

const UK_AND_IRE = ['GB', 'IE'];

const getEngagements = vd => (vd[LIKES] + vd[COMMENTS] + vd[SHARES]);
const getWatchTimeUKIre = viewingByCountry => {
  const ukAndIre = _.filter(viewingByCountry, vd => (_.includes(UK_AND_IRE, vd[ISO])));
  return _.reduce(ukAndIre, (result, vd) => (result + vd[MINS]), 0);
};

const getDemographics = (data, gender) => {
  const labels = ['age13-17', 'age18-24', 'age25-34', 'age35-44', 'age45-54', 'age55-64', 'age65-'];
  const demos = _.map(labels, label => {
    const dp = _.find(data, d => {
      if (d[0] === gender && d[1] === label) {
        return d[2];
      }
    });
    return dp;
  });

  const xxx = _.map(demos, d => d && d[2]);
  return xxx;
};

const getGenderPercentages = data => {
  const maleValues = _.filter(data, d => (d[0] === 'male'));
  const malePercentage = _.reduce(maleValues, (sum, d) => (sum + d[2]), 0);
  return {
    male: malePercentage,
    female: 100 - malePercentage,
  };
};

const Transformer = {
  getInfoSection: data => {
    const heroContent = _.find(data.posts, p => (p.trackedAsset.platform === 'YOUTUBE'));
    return {
      campaignName: data.name,
      influencerName: heroContent && heroContent.influencerName,
      reportDate: new Date(),
    };
  },

  getHeroPost: data => {
    const heroContent = _.find(data.posts, p => (p.trackedAsset.platform === 'YOUTUBE'));
    return heroContent;
  },

  getSupportingActivity: data => {
    const filteredPosts = _.filter(data.posts, post => (post.trackedAsset.platform !== 'YOUTUBE'));
    const supportingActivity = _.map(filteredPosts, post => ({
      platform: _.toLower(post.trackedAsset.platform),
      url: post.trackedAsset.assetURL,
      title: post.text,
      isVideo: post.isVideo,
      views: post.latestStatistic.insights && post.latestStatistic.insights.impressions,
      reach: post.latestStatistic.insights && post.latestStatistic.insights.reach,
      engagements: post.latestStatistic.insights && post.latestStatistic.insights.engagement,
      screenshot: post.thumbnail,
    }));

    return supportingActivity;
  },

  getSummaryData: data => {
    const heroContent = _.find(data.posts, p => (p.trackedAsset.platform === 'YOUTUBE'));
    const insights = heroContent.latestStatistic.insights;
    const vbc = insights.viewingByCountry;
    const heroEngagements = _.reduce(vbc, (result, vd) => (result + getEngagements(vd)), 0);
    const heroViews = heroContent.latestStatistic.viewCount;

    const filteredPosts = _.filter(data.posts, post => (post.trackedAsset.platform !== 'YOUTUBE'));

    return {
      totalViews: heroViews,
      totalImpressions: _.reduce(filteredPosts, (result, post) => {
        const ins = post.latestStatistic.insights;
        if (!ins) return result;
        return post.isVideo ? result + (ins.totalVideoImpressions || 0) : result + ins.impressions;
      }, 0),
      totalEngagements: heroEngagements + _.reduce(filteredPosts, (result, post) => {
        const ins = post.latestStatistic.insights;
        if (!ins) return result;
        return post.isVideo ? result : result + ins.engagement;
      }, 0),
    };
  },

  getHeroData: data => {
    const heroContent = _.find(data.posts, p => (p.trackedAsset.platform === 'YOUTUBE'));
    const insights = heroContent.latestStatistic.insights;
    const vbc = insights.viewingByCountry;
    const demoPercentages = insights.audienceDemographics;
    const barData = {
      labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'],
      datasets: [{
        label: 'male %',
        backgroundColor: dyzioPalette.blue,
        borderColor: dyzioPalette.bgBlue,
        borderWidth: 1,
        data: getDemographics(demoPercentages, 'male'),
      },
      {
        label: 'female %',
        backgroundColor: dyzioPalette.bgPink,
        borderColor: dyzioPalette.pink,
        borderWidth: 1,
        data: getDemographics(demoPercentages, 'female'),
      },
      ],
    };

    const genderPercentages = getGenderPercentages(demoPercentages);

    return {
      title: heroContent.title,
      subTitle: _.truncate(heroContent.description, {
        length: 300,
        separator: ' ',
      }),
      videoUrl: `https://www.youtube.com/watch?v=${heroContent.youtubeVideoId}`,
      views: heroContent.latestStatistic.viewCount,
      engagements: _.reduce(vbc, (result, vd) => (result + getEngagements(vd)), 0),
      watchTimeUKIre: getWatchTimeUKIre(vbc),
      watchTimeTotal: _.reduce(vbc, (result, vd) => (result + vd[MINS]), 0),
      donutData: {
        labels: [
          'male %',
          'female %',
        ],
        datasets: [{
          data: [genderPercentages.male, genderPercentages.female],
          backgroundColor: [
            dyzioPalette.blue,
            dyzioPalette.bgPink,
          ],
          borderColor: [
            dyzioPalette.bgBlue,
            dyzioPalette.pink,
          ],
          borderWidth: 1,
        }],
      },
      barData,
      viewingData: _.map(_.take(vbc, 5), vd => ({
        name: vd[ISO],
        watchTime: vd[MINS],
        views: vd[VIEWS],
        engagements: getEngagements(vd),
        likes: vd[LIKES],
      })),
    };
  },
};

export default Transformer;



// WEBPACK FOOTER //
// ./src/components/hero-report/transformer.js